import { render, staticRenderFns } from "./BirthdateInputs.vue?vue&type=template&id=316814f8"
import script from "./BirthdateInputs.vue?vue&type=script&lang=js"
export * from "./BirthdateInputs.vue?vue&type=script&lang=js"
import style0 from "./BirthdateInputs.vue?vue&type=style&index=0&id=316814f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports